import React, { useState, useEffect } from "react";

const ModernHero = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsVisible(true);

    // Check if it's a mobile device to optimize animations
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);

    return () => window.removeEventListener("resize", checkIfMobile);
  }, []);

  return (
    <section className="hero-modern">
      <div className="hero-modern-content">
        <h1
          className={`hero-modern-title ${
            isVisible ? "animate-fade-in-up" : ""
          }`}
        >
          Bienvenidos a <span className="text-gradient">Contasi</span>
        </h1>
        <p
          className={`hero-modern-subtitle ${
            isVisible ? "animate-fade-in-up" : ""
          }`}
          style={{ animationDelay: "0.2s" }}
        >
          Somos especialistas y te asesoramos en Contabilidades, Planificación
          Tributaria y Auditorias. Planificación Renta 2027 con los mejores
          profesionales.
        </p>
        <div
          className={`hero-modern-buttons ${
            isVisible ? "animate-fade-in-up" : ""
          }`}
          style={{ animationDelay: "0.4s" }}
        >
          <a
            href="#nuestros_servicios"
            className="btn-modern btn-modern-secondary animate-pulse"
          >
            <i
              className="fas fa-briefcase"
              style={{ marginRight: "0.5rem" }}
            ></i>
            <span className="d-none d-sm-inline">Nuestros </span>Servicios
          </a>
          <a
            href="https://wa.me/56961922323"
            className="btn-modern btn-modern-primary"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i
              className="fab fa-whatsapp"
              style={{ marginRight: "0.5rem" }}
            ></i>
            <span className="d-none d-sm-inline">Contactanos por </span>WhatsApp
          </a>
        </div>

        {/* Decorative floating elements - Only show on desktop for better mobile performance */}
        {!isMobile && (
          <>
            <div
              style={{
                position: "absolute",
                top: "20%",
                right: "10%",
                width: "60px",
                height: "60px",
                background: "rgba(255, 255, 255, 0.1)",
                borderRadius: "50%",
                animation: "float 8s ease-in-out infinite",
                animationDelay: "0s",
              }}
            ></div>

            <div
              style={{
                position: "absolute",
                top: "70%",
                left: "15%",
                width: "40px",
                height: "40px",
                background: "rgba(255, 255, 255, 0.1)",
                borderRadius: "50%",
                animation: "float 6s ease-in-out infinite",
                animationDelay: "2s",
              }}
            ></div>

            <div
              style={{
                position: "absolute",
                top: "40%",
                left: "5%",
                width: "30px",
                height: "30px",
                background: "rgba(255, 255, 255, 0.1)",
                borderRadius: "50%",
                animation: "float 10s ease-in-out infinite",
                animationDelay: "4s",
              }}
            ></div>
          </>
        )}
      </div>
    </section>
  );
};

export default ModernHero;
